import { formatCalendarDateToString } from "./dates";
import { formatBillingStatusLabel } from "./billingStatus";

/**
 * Display payment status for the Accounting table (legacy financial.asp Status column).
 */
export function formatAccountingPaymentStatus(
  status?: string,
): string {
  return formatBillingStatusLabel(status);
}

/**
 * Display comments for the Accounting table (legacy financial.asp Comments column).
 */
export function formatAccountingComments(
  comments?: string,
  dateWithdrawn?: string | Date | null,
  membershipStatus?: string,
): string {
  const parts: string[] = [];
  const memo = String(comments ?? "").trim();
  if (memo) {
    parts.push(
      memo.length > 30 ? `${memo.slice(0, 30)}...` : memo,
    );
  }

  const withdrawnStatuses = new Set(["Withdrawn", "Temporary Withdrawn"]);
  if (
    dateWithdrawn &&
    membershipStatus &&
    withdrawnStatuses.has(membershipStatus)
  ) {
    const withdrawnLabel = formatCalendarDateToString(dateWithdrawn);
    if (withdrawnLabel) {
      parts.push(`Withdrawn ${withdrawnLabel}`);
    }
  }

  return parts.join("\n");
}

/** Display currency for Accounting table amount columns (legacy hides zero/empty). */
export function formatAccountingAmount(value: unknown): string {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) {
    return "";
  }
  return `$${num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
